import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'interestTierrateFormat',
})
export class InterestTierrateFormatPipe implements PipeTransform {
  transform(value: string | number): string {
    if (value === null || value === undefined) return '';

    const str = String(value);

    // ถ้าทศนิยมเป็น 0 ทั้งหมด เช่น .0 .00 .000
    if (/\.0+$/.test(str)) {
      return str.replace(/\.0+$/, '');
    }

    return str;
  }
}
